'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TRAIT_ORDER_ID = exports.TRAIT_ORDER_ID = 'Order ID';
var TRAIT_COUPON_ID = exports.TRAIT_COUPON_ID = 'Coupon ID';
var TRAIT_DISCOUNT = exports.TRAIT_DISCOUNT = 'Discount';
var TRAIT_PRODUCT_ID = exports.TRAIT_PRODUCT_ID = 'Product ID';
var TRAIT_TOTAL = exports.TRAIT_TOTAL = 'Total';
var TRAIT_NAME = exports.TRAIT_NAME = 'Name';
var TRAIT_PRICE = exports.TRAIT_PRICE = 'Price';
var TRAIT_AFFILIATION = exports.TRAIT_AFFILIATION = 'Affiliation';
var TRAIT_CATEGORY = exports.TRAIT_CATEGORY = 'Category';
var TRAIT_QUANTITY = exports.TRAIT_QUANTITY = 'Quantity';
var TRAIT_CHECKOUT_ID = exports.TRAIT_CHECKOUT_ID = 'Checkout ID';
var TRAIT_PRODUCTS = exports.TRAIT_PRODUCTS = 'Products';
var TRAIT_STEP = exports.TRAIT_STEP = 'Step';
var TRAIT_LOCATION = exports.TRAIT_LOCATION = 'Location';
var TRAIT_POSITION = exports.TRAIT_POSITION = 'Position';
var TRAIT_BOOKMAKER = exports.TRAIT_BOOKMAKER = 'Bookmaker';
var TRAIT_BOOKMAKER_OFFER = exports.TRAIT_BOOKMAKER_OFFER = 'Bookmaker Offer';
var TRAIT_PRODUCT = exports.TRAIT_PRODUCT = 'Product';
var TRAIT_CURRENCY = exports.TRAIT_CURRENCY = 'Currency';

var TRAIT_ODDS = exports.TRAIT_ODDS = 'Odds';
var TRAIT_RACE_ID = exports.TRAIT_RACE_ID = 'Race ID';
var TRAIT_RACE_DATE = exports.TRAIT_RACE_DATE = 'Race date';
var TRAIT_RACE_TIME = exports.TRAIT_RACE_TIME = 'Race time';
var TRAIT_RACE_OFFERS_AVAILABLE = exports.TRAIT_RACE_OFFERS_AVAILABLE = 'Offer Available';
var TRAIT_TIME_OF_EVENT = exports.TRAIT_TIME_OF_EVENT = 'Time of event';
var TRAIT_RACECOURSE = exports.TRAIT_RACECOURSE = 'Racecourse';
var TRAIT_HORSE_NAME = exports.TRAIT_HORSE_NAME = 'Horse Name';
var TRAIT_BET_DATE = exports.TRAIT_BET_DATE = 'Bet Date';
var TRAIT_BETSLIP_ID = exports.TRAIT_BETSLIP_ID = 'Betslip ID';
var TRAIT_RECEIPT_ID = exports.TRAIT_RECEIPT_ID = 'Bet receipt ID';
var TRAIT_RECEIPT_TYPE = exports.TRAIT_RECEIPT_TYPE = 'Bet Receipt Type';
var TRAIT_BET_COUNT = exports.TRAIT_BET_COUNT = 'Bet Count';
var TRAIT_BET_TYPE = exports.TRAIT_BET_TYPE = 'Bet Type';
var TRAIT_STAKE = exports.TRAIT_STAKE = 'Stake';
var TRAIT_WIN_EW = exports.TRAIT_WIN_EW = 'Win / EW';
var TRAIT_API_OUTCOME = exports.TRAIT_API_OUTCOME = 'API Outcome';
var TRAIT_COUPON = exports.TRAIT_COUPON = 'Coupon';
var TRAIT_REVENUE = exports.TRAIT_REVENUE = 'Revenue';
var TRAIT_PACKAGE = exports.TRAIT_PACKAGE = 'Package';
var TRAIT_STATUS = exports.TRAIT_STATUS = 'Status';

var TRAIT_REWARDS_FOR_RACING = exports.TRAIT_REWARDS_FOR_RACING = 'Rewards For Racing';
var TRAIT_DAILY_CONTACT = exports.TRAIT_DAILY_CONTACT = 'Daily Contact';
var TRAIT_FIRST_NAME = exports.TRAIT_FIRST_NAME = 'First Name';
var TRAIT_LAST_NAME = exports.TRAIT_LAST_NAME = 'Last Name';
var TRAIT_PHONE_NUMBER = exports.TRAIT_PHONE_NUMBER = 'Phone Number';

var TRAIT_EMAIL = exports.TRAIT_EMAIL = 'Email';
var TRAIT_CREATED_AT = exports.TRAIT_CREATED_AT = 'Created At';
var TRAIT_OUTCOME = exports.TRAIT_OUTCOME = 'Outcome';
var TRAIT_ERROR = exports.TRAIT_ERROR = 'Error';

var TRAIT_RACINGPOST_CONTACT = exports.TRAIT_RACINGPOST_CONTACT = 'Racing Post Contact';
var TRAIT_THIRDPARTY_CONTACT = exports.TRAIT_THIRDPARTY_CONTACT = 'Third Party Contact';

var TRAIT_DEVICE_TYPE = exports.TRAIT_DEVICE_TYPE = 'Device Type';
var TRAIT_USER_NAME = exports.TRAIT_USER_NAME = 'Username';
var TRAIT_USER_ID = exports.TRAIT_USER_ID = 'User Id';
var TRAIT_LOGGED_IN_STATUS = exports.TRAIT_LOGGED_IN_STATUS = 'Logged In Status';
var TRAIT_BETTING_ACCOUNT_LOGGED_IN_STATUS = exports.TRAIT_BETTING_ACCOUNT_LOGGED_IN_STATUS = 'Betting Account Logged In Status';

var TRAIT_PACKAGE_ORIGIN = exports.TRAIT_PACKAGE_ORIGIN = 'Package Origin';
var TRAIT_PACKAGE_DESTINATION = exports.TRAIT_PACKAGE_DESTINATION = 'Package Destination';

var TRAIT_LAST_CHANGED_OPTION = exports.TRAIT_LAST_CHANGED_OPTION = 'Last Changed Option';

var TRAIT_RACE_CONDITIONS = exports.TRAIT_RACE_CONDITIONS = 'Race Conditions';
var TRAIT_FORM = exports.TRAIT_FORM = 'Form';
var TRAIT_MY_NOTES = exports.TRAIT_MY_NOTES = 'My Notes';
var TRAIT_SPOTLIGHTS = exports.TRAIT_SPOTLIGHTS = 'Spotlights';
var TRAIT_COMMENTS = exports.TRAIT_COMMENTS = 'Comments';
var TRAIT_OWNER = exports.TRAIT_OWNER = 'Owner';
var TRAIT_QUOTES = exports.TRAIT_QUOTES = 'Quotes';
var TRAIT_PEDIGREES = exports.TRAIT_PEDIGREES = 'Pedigrees';
var TRAIT_RTF = exports.TRAIT_RTF = 'RTF%';
var TRAIT_DECIMAL_ODDS = exports.TRAIT_DECIMAL_ODDS = 'Decimal Odds';
var TRAIT_PRICE_HISTORY = exports.TRAIT_PRICE_HISTORY = 'Price History';
var TRAIT_ORDER_BY_PRICE = exports.TRAIT_ORDER_BY_PRICE = 'Order by Price';
var TRAIT_BETTING_FORCAST = exports.TRAIT_BETTING_FORCAST = 'Betting Forecast';
var TRAIT_MY_RATINGS = exports.TRAIT_MY_RATINGS = 'My Ratings';
var TRAIT_SHOW_PRICES = exports.TRAIT_SHOW_PRICES = 'Show Prices';

var TRAIT_HORSE_ENTERED = exports.TRAIT_HORSE_ENTERED = 'Horse Entered';
var TRAIT_HORSE_DECLARED = exports.TRAIT_HORSE_DECLARED = 'Horse Declared';
var TRAIT_SHOW_PEDIGREE = exports.TRAIT_SHOW_PEDIGREE = 'Show Pedigree';

var TRAIT_SELECTION = exports.TRAIT_SELECTION = 'Selection';

var TRAIT_SITE_SECTION = exports.TRAIT_SITE_SECTION = 'Site Section';
var TRAIT_SITE_SUB_SECTION_1 = exports.TRAIT_SITE_SUB_SECTION_1 = 'Site Sub Section 1';
var TRAIT_SITE_SUB_SECTION_2 = exports.TRAIT_SITE_SUB_SECTION_2 = 'Site Sub Section 2';

var TRAIT_HORSE_BETTING = exports.TRAIT_HORSE_BETTING = 'Communication Horse Betting';
var TRAIT_HORSE_NEWS = exports.TRAIT_HORSE_NEWS = 'Communication Horse News';
var TRAIT_COMPETITIONS = exports.TRAIT_COMPETITIONS = 'Communication Competitions';
var TRAIT_BLOODSTOCK = exports.TRAIT_BLOODSTOCK = 'Communication Bloodstock';
var TRAIT_SPORT_BETTING = exports.TRAIT_SPORT_BETTING = 'Communication Sport Betting';
var TRAIT_OVER_EIGHTEEN = exports.TRAIT_OVER_EIGHTEEN = 'Communication Eighteen';
var TRAIT_DAYLY_UPDATES = exports.TRAIT_DAYLY_UPDATES = 'Daily Contact';
var TRAIT_R4R = exports.TRAIT_R4R = 'Rewards For Racing';
var TRAIT_THIRD_PARTY = exports.TRAIT_THIRD_PARTY = 'Third Party Contact';

var TRAIT_ACCORDION_NAME = exports.TRAIT_ACCORDION_NAME = 'Accordion Name';


//////////////////
// WEBPACK FOOTER
// ./~/rp-betting-special-offer/~/rp-analytics/lib/traits.js
// module id = 5
// module chunks = 0